<template>
  <div>
    <div>
      <span v-if="warningMessage.length > 0" class="error">
        {{ warningMessage }}
        <br />
      </span>
      <span v-for="suggestion in suggestions" :key="suggestion" class="error">
        {{ suggestion }}
        <br />
      </span>
      <span v-if="successMessage.length > 0" class="success">
        {{ successMessage }}
        <br />
      </span>
    </div>
    <form @submit="resetPassword" class="password-change">
      <h2>Change Password</h2>
      <div class="form-group">
        <b
          >Passwords must consist of minimal 8 characters, and include at least
          one number and one uppercase letter.</b>
      </div>
      <div class="form-group">
        <label>Current password:</label>
        <input
          id="current-pass"
          name="old"
          v-model="form.currentPassword"
          type="password"
          required
        />
      </div>
      <div class="form-group">
        <label>New password:</label>
        <input
          id="new-pass"
          name="new"
          v-model="form.newPassword"
          type="password"
          required
        />
      </div>
      <div class="form-group">
        <label>Confirm New password:</label>
        <input
          id="confirm-new-pass"
          name="new2"
          v-model="form.confirmPassword"
          type="password"
          required
        />
      </div>
      <button
        type="submit"
        class="bbutton submit-form"
        :disabled="
          !form.currentPassword.length ||
          !form.newPassword.length ||
          !form.confirmPassword.length
        ">
        Change Password
      </button>
    </form>
    <form>
      <hr />
      <div>
        <h2>MFA (Multi-Factor Authentication)</h2>
        <div class="margin-left-2">
          <div>
            <p><strong>Enable MFA (Multi-Factor Authentication)</strong></p>
            Add an extra layer of security to your My Acclaro account by
            enabling multifactor authentication.
          </div>
          <div>
            Once enabled, you will be required to provide a security code when
            you sign in to My Acclaro. That code will be sent to your email
            address on file.
          </div>
        </div>
        <div
          v-if="showPopup"
          class="token-revoked-popup position-popup"
        >
          <CheckCircleIcon /> &nbsp;{{ popupText }}
        </div>
      </div>
      <br />

      <div class="margin-left-2">
        <div>
          <label>
            <input
              type="checkbox"
              v-model="mfaEnabled"
              @change="toggleMFA"
              :disabled="accountMfaEnforced"
            />
            <b>Enable Email MFA</b>
          </label>
        </div>
      </div>
      <br />
      <div class="margin-left-2">
        <p  class="margin-0">
          <strong>Note:</strong> if MFA has been enabled as mandatory for your
          organization, you will not be able to change this setting here.
        </p>
      </div>
    </form>
  </div>
</template>
<script>
import axios from "axios";
import "./style.scss";
import {
  EyeIcon,
  CheckCircleIcon,
  EyeOffIcon,
  ContentCopyIcon,
} from "../icons.js";
export default {
  components: {
    EyeIcon,
    EyeOffIcon,
    ContentCopyIcon,
    CheckCircleIcon,
  },
  mounted() {
    this.getUserMFASetting();
  },
  data() {
    return {
      form: {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      mfaEnabled: false,
      loadedMfaSetting: false,
      accountMfaEnforced: false,
      warningMessage: "",
      suggestions: "",
      successMessage: "",
      loaded: false,
      showPopup: false,
      popupText: "",
      timout: null
    };
  },
  props: {
    resetPasswordRoute: {
      type: String,
      default: "",
    },
    toggleMfaRoute: {
      type: String,
      default: "",
    },
  },
  computed: {},
  watch: {
    popupText: function () {
      if ( this.timeout ) {
        clearTimeout(this.timeout)
      }
      this.timeout = setTimeout(() => {
              this.showPopup = false;
            }, 2000);
    }
  },
  methods: {
    resetPassword(evt) {
      evt.preventDefault();
      axios
        .post(this.resetPasswordRoute, {
          old_password: this.form.currentPassword,
          password: this.form.newPassword,
          password_confirmation: this.form.confirmPassword,
        })
        .then((response) => {
          this.resetForm();
          if (response?.data?.success) {
            this.successMessage = "Password updated";
          } else {
            this.errorMessage = response?.data.responseData;
            this.warningMessage = response?.data.responseData?.warning;
            this.suggestions = response?.data.responseData?.suggestions;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getUserMFASetting() {
      axios
        .get("/settings/mfa")
        .then((response) => {
          const res = response.data;
          this.accountMfaEnforced = res.account_mfa_enforced;
          this.mfaEnabled = res.user_mfa_enabled || res.account_mfa_enforced;
          this.loadedMfaSetting = true;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    toggleMFA() {
      if (this.accountMfaEnforced) {
        return;
      }
      console.log(this.mfaEnabled);
      axios
        .post("/settings/mfa", {
          mfa_enabled: this.mfaEnabled,
        })
        .then((response) => {
          this.resetForm();
          if (response?.data?.success) {
            this.showPopup = true;
            if (this.mfaEnabled) {
              this.popupText = "MFA enabled.";
            }
            else {
              this.popupText = "MFA disabled.";
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });

    },
    resetForm() {
      this.form.currentPassword = "";
      this.form.newPassword = "";
      this.form.confirmPassword = "";
      this.warningMessage = "";
      this.suggestions = "";
      this.successMessage = "";
    },
  },
};
</script>
<style scoped>
h2 {
  font-size: 22px;
  font-weight: 300;
}

.margin-left-2 {
  margin-left: 2%;
}

.margin-0 {
  margin: 0;
}

.position-popup {
  margin-left: 13%;
  position: absolute
}
</style>
